import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Bag04 = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 20 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        d="M12 6.5V4C12 2.34315 10.6569 1 9 1C7.34314 1 6 2.34315 6 4V6.5M2.93939 18H15.0606C16.1317 18 17 17.1478 17 16.0967L15.7576 5.99997C15.7576 4.94879 14.8893 4.09663 13.8182 4.09663H3.93939C2.8683 4.09663 2 4.94879 2 5.99997L1 16.0967C1 17.1478 1.8683 18 2.93939 18Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
})

export default Bag04
